export default __webpack_public_path__ + "static/media/gallery_09.f42c3e07.jpg";